import { HumanFemaleDanceIcon } from './HumanFemaleDanceIcon';

/**
 * author: Michael Richins
 * id DCBC03CA-8A3A-41FD-9C96-BA738EDA9F05
 * name human-female-dance
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-female-dance.svg
 * tags
 * - People / Family 
 * - Sport 
 */
export const BalletIcon = HumanFemaleDanceIcon;
export default BalletIcon